/**
 * Registers vendored nedi-ui-web custom elements + CSS and pins contract 2.0.0.
 * Artifact: vendor/nedi-ui-web-0.2.0-alpha.tgz (no sibling ../../nedi-ui import).
 */
import 'nedi-ui-web/style.css'
import 'nedi-ui-web'
import { contractVersion, contractChecksum } from 'nedi-ui-web/contract'

export const NEDI_CONTRACT_VERSION = contractVersion
export const NEDI_CONTRACT_CHECKSUM = contractChecksum
export const NEDI_UI_WEB_VERSION = '0.2.0-alpha'

/**
 * @param {object} [opts]
 * @param {boolean} [opts.activateSuiteGlass]
 * @param {HTMLElement|null} [opts.root]
 */
export function mountNediTheme({
  activateSuiteGlass = false,
  root = typeof document !== 'undefined' ? document.documentElement : null,
} = {}) {
  if (!root) return
  root.setAttribute('data-nedi-contract', NEDI_CONTRACT_VERSION)
  root.setAttribute('data-nedi-contract-checksum', NEDI_CONTRACT_CHECKSUM)
  root.setAttribute('data-nedi-ui-web', NEDI_UI_WEB_VERSION)
  if (activateSuiteGlass) {
    root.setAttribute('data-theme', 'suite-glass')
  }
}
